import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5007e3e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-3 print" }, "Review of Answers", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "button",
  value: "Print your answers",
  class: "btn btn-link text-dark",
  onclick: "window.print();return false;"
}, null, -1))
const _hoisted_4 = { class: "printonly print" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "User ID:", -1))
const _hoisted_6 = { class: "question print" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "print"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "print" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "question print" }, " What other assets do you have? ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "print" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "question print" }, "Your state pension:", -1))
const _hoisted_13 = {
  key: 1,
  class: "print"
}
const _hoisted_14 = {
  key: 2,
  class: "print"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.userId), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedAnswers, (storedAnswer) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: storedAnswer.questionId
        }, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", {
              innerHTML: _ctx.getQuestionText(storedAnswer.questionId)
            }, null, 8, _hoisted_7)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storedAnswer.responses, (response, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (response && response.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.getMultipartAnswerPrefix(storedAnswer.questionId, i)) + _toDisplayString(response), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _hoisted_9
        ], 64))
      }), 128)),
      (_ctx.storedPots.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedPots, (storedPot) => {
              return (_openBlock(), _createElementBlock("p", {
                key: storedPot.id,
                class: "print"
              }, "- " + _toDisplayString(storedPot.description()), 1))
            }), 128)),
            _hoisted_11
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_12,
      (_ctx.storedStatePension.hasPension())
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, " This is estimated as " + _toDisplayString(_ctx.formatter.formatCurrency(_ctx.storedStatePension.amount)) + " a year from your state pension age (" + _toDisplayString(_ctx.storedStatePension.entitlementDate) + "). ", 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_14, " You have not worked or looked after children for enough time to qualify for the state pension. "))
    ])
  ], 64))
}